<app-modal
  [title]="'Editar contacto'"
  [loading]="loading"
  [scrollable]="true"
>
      <app-form [formGroup]="editForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
          <div>
            <app-label for="nombre">
              Nombre
            </app-label>
            <app-input-field id="nombre" type="text" formControlName="nombre" placeholder="Ingrese el nombre" />
          </div>

          <div>
            <app-label for="apellido">
              Apellido
            </app-label>
            <app-input-field id="apellido" type="text" formControlName="apellido" placeholder="Ingrese el apellido" />
          </div>

          <div>
            <app-label for="celular">
              Celular
            </app-label>
            <app-input-field id="celular" type="text" formControlName="celular" placeholder="Ingrese el celular" />
          </div>

          <div>
            <app-label for="param_establecimiento_tipo_contacto_id">
              Tipo de contacto
            </app-label>
            <app-select id="param_establecimiento_tipo_contacto_id" formControlName="param_establecimiento_tipo_contacto_id" placeholder="Seleccione" [options]="tiposContactosAdministrativosOptions" />
          </div>

          <div>
            <app-label for="email">
              Email
            </app-label>
            <app-input-field id="email" type="email" formControlName="email" placeholder="Ingrese el email" />
          </div>

          <!--
            Issue #26 (2026-09-15): antes era un chip de solo lectura. Vaciarlo convierte
            el contacto en administrativo del cliente; elegir un establecimiento lo pasa
            a contacto de ese establecimiento.
          -->
          <div>
            <app-label for="cli_establecimiento_id">
              Establecimiento
            </app-label>
            <app-select id="cli_establecimiento_id" formControlName="cli_establecimiento_id" placeholder="Ninguno (contacto administrativo)" [options]="establecimientosOptions" />
          </div>

          <div>
            <app-label for="activo">
              Estado
            </app-label>
            <!-- El switch se deshabilita solo en modo lectura (ControlValueAccessor) -->
            <div class="flex items-center gap-3 mt-2">
              <app-switch id="activo" formControlName="activo"></app-switch>
              <span class="text-sm text-gray-700 dark:text-gray-300">
                {{ editForm.get('activo')?.value ? 'Activo' : 'Inactivo' }}
              </span>
            </div>
          </div>
        </div>
      </app-form>

    <app-edition-buttons *hasPermission="'clientes:edit'"
      [valid]="editForm.valid"
      [editable]="editable"
      [process]="updating"
      [hideEditButton]="true"
      (onUpdateClick)="update()"
      (onCancelClick)="close()"
      (onGoBackClick)="close()"
    />
</app-modal>
